(function (window, document, undefined) {
  "use strict";

  let logger = {},
    Vue,
    vodl_tts,
    textToSpeech,
    url = "",
    apiUrl = "/wp-json/tts/v1/speech_service";

  /**
   * Initialize.
   * Check if Vue is available, get the widget data.
   */
  const _init = (tts) => {
    Vue = window.Vue || false;

    if (!Vue) {
      logger.log("No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let id = tts.id;
    let post_id = tts.getAttribute("data-id");
    let source = tts.getAttribute("data-src");

    textToSpeech = Vue.createApp({
      components: {
        AudioWrapper: window["@russmedia-frontend/common"].AudioWrapper,
      },
      data() {
        return {
          source: source,
          postId: post_id,
          autoplay: true,
        };
      },
      methods: {
        onLoad() {
          trackGAEvent("open");
          logger.log("loadPlayer()");
        },
        fetchData(postId) {
          fetch_data(postId);
          logger.log("loadPlayer()");
        },
        onPlay(e) {
          trackGAEvent("play");
          logger.log("play()");
        },
        onPause(e) {
          logger.log("pause()", e.progress);
          switch (true) {
            case e.progress <= 5:
              trackGAEvent("0-5%");
              break;
            case e.progress <= 25:
              trackGAEvent("5-25%");
              break;
            case e.progress <= 50:
              trackGAEvent("25-50%");
              break;
            case e.progress <= 75:
              trackGAEvent("50-75%");
              break;
            case e.progress <= 95:
              trackGAEvent("75-95%");
              break;
            default:
              trackGAEvent(">95%");
          }
        },
      },
    }).mount("#" + id);

    document.addEventListener("vodl_show_full_content", (e) => {
      document.getElementById(id).classList.remove("vodl-tts--hidden");
    });
  };

  /**
   * Fetch audio data via nnp rest API.
   * If successful set source for vue instance.
   */
  const fetch_data = (post_id) => {
    url = window.location.protocol + "//" + window.location.hostname + apiUrl;
    //url = 'http://nnp-vol-local.medienhaus.com/wp-json/tts/v1/speech_service';
    logger.log("fetch_data()", url + "?p=" + post_id);

    fetch(url + "?p=" + post_id)
      .then(function (response) {
        // The API call was successful!
        return response.json();
      })
      .then(function (data) {
        if (data.file) {
          logger.log("fetch_data()", "file: " + data.file);
          textToSpeech.source = data.file;
        } else {
          console.warn(data.code, data.message);
        }
      })
      .catch(function (err) {
        // There was an error.
        console.warn("[tts]", err);
      });
  };

  /**
   * Track google analytics events.
   */
  const trackGAEvent = (action) => {
    if ("undefined" === typeof dataLayer || null === dataLayer) {
      return;
    }

    const eventData = {
      event: "genericEvent",
      eventCategory: "TextToSpeech",
      eventAction: action,
      eventLabel: window.location.href,
    };

    dataLayer.push(eventData);

    document.dispatchEvent(
      new CustomEvent("hansrmdtevent", { detail: eventData })
    );

    logger.log("trackGAEvent()", action);
  };

  document.addEventListener("DOMContentLoaded", (e) => {
    try {
      logger = new window.RussMedia.Utils.Logger("[tts] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    vodl_tts = document.getElementsByClassName("vodl-tts");
    // should be there only once per page, but to be sure ...
    Array.from(vodl_tts).forEach((tts) => {
      _init(tts);
    });
  });
})(window, document);
